import { projects } from '../../../mocks/projectsData';

export default function ProjectsSection() {
  return (
    <section id="projects" className="py-32 bg-dark relative overflow-hidden">
      {/* Background Elements */}
      <div className="absolute top-1/3 right-0 w-96 h-96 bg-primary/5 rounded-full blur-3xl"></div>
      <div className="absolute bottom-1/3 left-0 w-96 h-96 bg-primary/5 rounded-full blur-3xl"></div>

      <div className="max-w-[1400px] mx-auto px-8 relative z-10">
        {/* Header */}
        <div className="text-center mb-20">
          <h2 className="text-5xl font-bold text-white mb-6">
            Unsere entwickelten Projekte
          </h2>
          <p className="text-xl text-gray-400 max-w-3xl mx-auto leading-relaxed">
            Innovative KI-basierte Lösungen für verschiedene Branchen und Anwendungsfälle – von der Konzeption bis zur Umsetzung.
          </p>
        </div>

        {/* Projects Grid */}
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-8">
          {projects.map((project) => (
            <div
              key={project.id}
              className="bg-dark-lighter rounded-3xl p-10 transition-all duration-300 hover:-translate-y-2 hover:shadow-2xl hover:shadow-primary/20 cursor-pointer group border border-white/5"
            >
              {/* Header */}
              <div className="flex items-start gap-6 mb-6">
                {/* Icon */}
                <div className="w-16 h-16 rounded-2xl bg-gradient-to-br from-primary to-primary-light flex items-center justify-center flex-shrink-0 group-hover:scale-110 transition-transform duration-300">
                  <i className={`${project.icon} text-3xl text-white`}></i>
                </div>

                {/* Title */}
                <div className="flex-1">
                  <h3 className="text-2xl font-bold text-white mb-2">
                    {project.title}
                  </h3>
                  <p className="text-primary text-sm font-medium">
                    {project.subtitle}
                  </p>
                </div>
              </div>

              {/* Description */}
              <p className="text-gray-400 leading-relaxed mb-6">
                {project.description}
              </p>

              {/* Features List */}
              <div className="mb-6">
                <h4 className="text-white font-semibold mb-4 text-sm uppercase tracking-wider">
                  Leistungsumfang
                </h4>
                <ul className="space-y-2">
                  {project.features.map((feature, index) => (
                    <li key={index} className="flex items-start gap-3">
                      <i className="ri-checkbox-circle-fill text-primary text-base mt-0.5 flex-shrink-0"></i>
                      <span className="text-sm text-gray-400">{feature}</span>
                    </li>
                  ))}
                </ul>
              </div>

              {/* Einsatzbereich */}
              <div className="pt-6 border-t border-white/5">
                <h4 className="text-white font-semibold mb-2 text-sm uppercase tracking-wider">
                  Einsatzbereich
                </h4>
                <p className="text-sm text-gray-400">
                  {project.einsatzbereich}
                </p>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
